import axios from './_nestAxios'

export const obtenerAsTablaFactores = idCentroCosto =>
  axios.get('/factores-costo', {
    params: {
      tipoConsulta: 'tabla-factores',
      idCentroCosto: idCentroCosto
    }
  })

export const actualizarMasivo = data => axios.put('/factores-costo/actualizar-masivo', data)
